import { CatalogTab } from "@pages/Catalog/components/utils";

import { AdditionalQueryParams, FiltersType, queryConfig } from "@hooks/useFiltersQuery/utils/constants";

import { ERoutes } from "@utils/constants";
import queryString from "query-string";
import { ArrayParam, encodeQueryParams, ObjectParam } from "use-query-params";

export const navigateToCatalogWithQuery = (query: string, queryType: FiltersType) => {
  // For composer and tags, use the search-based ?q= approach
  // Use a plain string path to avoid query-params library merging existing params
  if (queryType === FiltersType.COMPOSER || queryType === FiltersType.TAGS) {
    return `${ERoutes.Catalog}?q=${encodeURIComponent(query)}&t=${Date.now()}&isAlbumsTab=track`;
  }

  const isRange = queryType === FiltersType.LENGTH || queryType === FiltersType.BPM;
  const searchParams = isRange
    ? {
        min: "0",
        max: query,
      }
    : [query];

  const params = {
    [FiltersType.IS_ALBUMS_TAB]: CatalogTab.TRACK,
    [FiltersType.PAGE_NUMBER]: "1",
    [FiltersType.IS_FILTERS_OPEN]: "1",
    [AdditionalQueryParams.JUMP]: "1",
  };

  const encodedQuery = encodeQueryParams(
    { [queryType]: isRange ? ObjectParam : ArrayParam, ...queryConfig },
    { [queryType]: searchParams, ...params },
  );

  return {
    pathname: ERoutes.Catalog,
    search: queryString.stringify(encodedQuery).replace(/%20/g, "+"),
  };
};
